import React from "react";
import { stepStyles } from "./formStyles";

export const Review = ({ formData, navigation }) => {
  const { go } = navigation;
  const { firstName, lastName, address, city, state, zip, phone, email } = formData;

  return (
    <div className={stepStyles.page}>
      <div className={stepStyles.content}>
        <div className="mx-auto flex w-full max-w-4xl flex-col gap-5 rounded-4xl border border-brand-border bg-white/92 px-6 py-8 shadow-panel backdrop-blur-sm md:px-10 md:py-10">
          <h1 className={stepStyles.title}>Review your information</h1>
          <RenderSection
            summary="Names"
            go={go}
            details={[
              { label: "First Name", value: firstName },
              { label: "Last Name", value: lastName },
            ]}
          />
          <RenderSection
            summary="Address"
            go={go}
            details={[
              { label: "Address", value: address },
              { label: "City", value: city },
              { label: "State", value: state },
              { label: "Zip", value: zip },
            ]}
          />
          <RenderSection
            summary="Contact"
            go={go}
            details={[
              { label: "Phone", value: phone },
              { label: "Email", value: email },
            ]}
          />
        </div>
      </div>
      <div className={stepStyles.actionBar}>
        <div className={stepStyles.actionRow}>
          <button className={`${stepStyles.buttonAlt} w-full md:w-auto`} onClick={() => go("contact")}>
            Back
          </button>
          <button className={`${stepStyles.button} w-full md:w-auto`} onClick={() => go("submit")}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export const RenderSection = ({ summary, details, go }) => (
  <div className="rounded-3xl border border-brand-border bg-brand-canvas px-5 py-5">
    <div className="flex items-center justify-between gap-4 border-b border-brand-border pb-4">
      <h2 className="text-left text-xl font-semibold text-brand-ink">{summary}</h2>
      <button
        className="text-sm font-semibold uppercase tracking-[0.14em] text-blue-primary hover:text-green-primary"
        onClick={() => go(summary.toLowerCase())}
      >
        Edit
      </button>
    </div>
    <div className="mt-4 grid gap-3 md:grid-cols-2">
      {details.map((item, index) => (
        <div key={index} className="rounded-2xl bg-white px-4 py-3 shadow-sm">
          <div className="text-xs font-semibold uppercase tracking-[0.12em] text-gray-satan">{item.label}</div>
          <div className="mt-1 text-base font-semibold text-brand-ink">{item.value || "-"}</div>
        </div>
      ))}
    </div>
  </div>
);
